module.exports = "<div>This is the icon-choice view.</div>\n<div>I bear this message: {{message}}</div>\n"